import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../shared/providers/toast.service';
import { ComparePropertiesModel } from '../../shared/models/ComparePropertiesModel';
import { ComparisonService } from '../../shared/providers/comparison.service';
import { ComparePropertyDetailModel } from '../../shared/models/ComparePropertyDetailModel';
import { ComparePropertyDataTotalOrAvgModel } from '../../shared/models/ComparePropertyDataTotalOrAvgModel';
//import { Chart } from 'angular-highcharts';
import { Trade1031Service } from '../../shared/providers/Trade1031.service';
import { IExchangeProperties } from '../../shared/models/ExchangePropertiesOutputModel';
import { MaxValuesComparisonModel } from '../../shared/models/MaxValuesComparisonModel';
import html2canvas from 'html2canvas';
//import * as jsPDF from 'jspdf';
import { LoaderService } from '../../shared/providers/loader.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import * as Highcharts from 'highcharts';
declare var require: any;
if (typeof Highcharts === 'object') {
  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}

@Component({
  selector: 'app-property-comparison',
  templateUrl: './property-comparison.component.html',
})
export class PropertyComparison implements OnInit {
  constructor(
    private _ValidationService: ValidationService,
    private router: Router,
    private comparisonService: ComparisonService,
    private _toastService: ToastService,
    private modalService: BsModalService,
    private Toast: ToastService,
    private trade1031Service: Trade1031Service,
    protected loaderService: LoaderService,
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute
  ) {}

  @Input() isPropertyAnalysis: boolean;
  @Input() isFromViewPage: boolean;
  comparePropertiesModel = {} as ComparePropertiesModel;
  comparePropertyDetailModelList: ComparePropertyDetailModel[];
  comparePropertyDetailCheckedModelList: ComparePropertyDetailModel[];
  analyzePropertyDetailModelList: ComparePropertyDetailModel[];
  comparePropertyDataTotalOrAvgModel = {} as ComparePropertyDataTotalOrAvgModel;
  isAnalyze: boolean = false;
  modalRef: BsModalRef;
  //priceChart = new Chart();
  //NOIChart = new Chart();
  //returnDuringLeaseChart = new Chart();
  //capRateChart = new Chart();
  //remainingTermChart = new Chart();
  //landAreaChart = new Chart();
  // creditRatingChart = new Chart();
  //revenueChart = new Chart();
  priceTotal: number;
  year: Date = new Date();
  currentYear: number;
  expirationYear: number;
  leaseExpirationYear: number;
  exchangePropertyList: IExchangeProperties[];
  haveaccesstoviewlocation: boolean = true;
  comparePropertiesLength: number;
  maxCompareValues: MaxValuesComparisonModel;
  user: any;
  isAnalyzeName: boolean = false;
  enableExtendedChart: boolean = false;
  analyzeId: number = 0;
  isSaveDisabled: boolean = false;
  //exchange1031Id:

  prevPage = '1031 Trade';
  prevPageRouteLink = 'dashboard-1031?tab=portfolio';
  disableAdd = false;
  showNodata = false;
  isFromOfferPortfolio = false;
  // Add this shared chart options object at class level
  private chartLabelOptions = {
    style: {
      fontSize: '12px'
    }
  };

  ngOnInit() {
    this.loaderService.display(true);
    pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let routeLink = params['link'];
      if (routeLink !== null && routeLink !== undefined) {
        this.prevPageRouteLink = routeLink;
      }
    });

    this.analyzeId = 0;
    this.activatedRoute.params.subscribe((params) => {
      if (params.analyzeId != undefined && !Number.isNaN(params.analyzeId)) {
        this.analyzeId = Number(params.analyzeId);
      }
    });

    this.user = this.authService.user;
    if (
      !this.authService.Admin() &&
      !this.authService.SuperAdmin() &&
      !this.authService.Broker() &&
      !this.authService.DataEntryStaff()
    ) {
      this.haveaccesstoviewlocation = false;
    } else {
      this.haveaccesstoviewlocation = true;
    }
    this.currentYear = this.year.getFullYear();

    if (
      this.analyzeId != undefined &&
      this.analyzeId != 0 &&
      !Number.isNaN(this.analyzeId)
    ) {
      this.comparisonService
        .getAnalyzeDetail(this.analyzeId)
        .subscribe((response) => {
          this.comparePropertiesModel = response;
          this.comparePropertiesLength =
            this.comparePropertiesModel.PropertyIds.length;
          this.analyzePropertyDetailModelList = [];
          this.loadComparePropertyData(false);
          this.comparePropertiesModel.UserId = this.user.Id;
          this.isPropertyAnalysis =
            this.comparePropertiesModel.IsPropertyAnalysis;
        });
    } else {
      this.analyzeId = 0;
      this.comparePropertiesModel =
        this.comparisonService.comparePropertiesModelData;

      this.comparePropertiesLength =
        this.comparePropertiesModel.PropertyIds.length;
      this.analyzePropertyDetailModelList = [];
      this.loadComparePropertyData(false);
      this.comparePropertiesModel.UserId = this.user.Id;
      this.comparePropertiesModel.IsPropertyAnalysis = this.isPropertyAnalysis;
    }
  }

  loadComparePropertyData(isFromNgOnInit) {
    //if (this.comparePropertiesModel.Exchange1031Id != undefined) {
    //    this.comparisonService.getPropertyDetailForComparison(this.comparePropertiesModel).subscribe(response => {
    //        this.comparePropertyDetailModelList = response;
    //        this.getColumnTotalOrAvg();
    //        if (isFromNgOnInit) {
    //            this.modalRef.hide();
    //        }
    //        //else {
    //        let analyseListData = [];
    //        this.comparePropertyDetailModelList.forEach(item => {
    //            item.IsChecked = true;
    //            this.analyzePropertyDetailModelList.push(item);
    //            if (item.LeaseCommencementYear != 0) {
    //                analyseListData.push(item.LeaseExpirationYear);
    //            }
    //        });
    //        analyseListData = analyseListData.sort();
    //        this.expirationYear = analyseListData[analyseListData.length - 1];

    //        this.analyze();
    //        // }
    //    });

    //}
    if (this.comparePropertiesModel.Exchange1031Id != undefined) {
      this.comparisonService
        .getPropertyDetailWithRentTermForComparison(this.comparePropertiesModel)
        .subscribe((response) => {
          this.comparePropertyDetailModelList = response;
          this.getColumnTotalOrAvg();
          if (isFromNgOnInit) {
            this.modalRef.hide();
          }
          //else {
          let analyseListData = [];
          this.comparePropertyDetailModelList.forEach((item) => {
            item.IsChecked = true;
            this.analyzePropertyDetailModelList.push(item);
            if (item.LeaseCommencementYear != 0) {
              analyseListData.push(item.LeaseExpirationYear);
            }
            if (item.CharacteristicsId.includes(2908)) {
              item.capRateText = 'ZCF';
              item.CapRate = 0;
            }
            if (
              this.haveaccesstoviewlocation == false &&
              item.ConfidentialLocation != null &&
              item.ConfidentialLocation
            ) {
              item.PropertyName = item.TenantName + ' - Confidential';
            }
          });
          analyseListData = analyseListData.sort();
          this.expirationYear = analyseListData[analyseListData.length - 1];

          this.analyze();
          this.loaderService.display(false);
          // }
        });
    } else {
      this.loaderService.display(false);
    }
  }

  analyze(fromHtml = false) {
    if (this.analyzePropertyDetailModelList.length > 1) {
      this.showNodata = false;
      this.isAnalyze = true;
      this.bindPriceChart();
      this.bindNOIChart();
      if (this.isPropertyAnalysis) {
        this.bindCapRateChartForPrpertyAnalysis();
      } else {
        this.bindCapRateChart();
      }

      //this.bindLandAreaChart();
      setTimeout(() => {
        this.bindRemainingTermChart();
        this.bindLandAreaChart();
      }, 10);
      setTimeout(() => {
        this.bindCreditRatingChart();
      }, 10);
      setTimeout(() => {
        this.bindRevenueChart();
      }, 10);
      this.bindReturnDuringLeaseChart();
      var element = document.getElementById('divAnalytics');

      if (!this.isFromViewPage) {
        this.scrollToBottom(element, 790);
      }
    } else {
      if (fromHtml) {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'Please select at least 2 properties',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      } else {
        this.showNodata = true;
      }
    }
  }

  openModalForAddProperty(template: TemplateRef<any>, classes: any) {
    this.disableAdd = true;
    this.comparePropertiesModel.TenentIds = [];
    this.comparePropertyDetailCheckedModelList = [];
    this.trade1031Service
      .GetPortfolioList(
        this.comparePropertiesModel.Exchange1031Id,
        this.user.Id
      )
      .subscribe((res) => {
        this.exchangePropertyList = res;
        this.exchangePropertyList.forEach((item) => {
          if (
            item.OfferPlaced == 460 &&
            item.OfferExchangeId != 0 &&
            item.OfferExchangeId != null
          ) {
            item.Title = 'Offer Accepted';
          } else if (
            item.OfferPlaced == 462 &&
            item.OfferExchangeId != 0 &&
            item.OfferExchangeId != null
          ) {
            item.Title = 'Hard Contract';
          } else if (
            item.OfferPlaced == 455 &&
            item.OfferExchangeId != 0 &&
            item.OfferExchangeId != null
          ) {
            item.Title = 'Under Contract';
          } else if (
            item.OfferPlaced == 456 &&
            item.OfferExchangeId != 0 &&
            item.OfferExchangeId != null
          ) {
            item.Title = 'Closed';
          } else if (
            item.OfferPlaced != 0 &&
            item.OfferExchangeId != 0 &&
            item.OfferExchangeId != null
          ) {
            item.Title = 'Pending Offer';
          } else if (item.GroupId == 2203) {
            item.Title = 'Pending Offer';
          }
        });
        this.comparePropertiesModel.PropertyIds.forEach((item) => {
          this.exchangePropertyList = this.exchangePropertyList.filter(
            (data) => data.PropertyId != item
          );
        });
        if (this.exchangePropertyList.length > 0) {
          // this.isAnalyze = false;
          //this.analyzePropertyDetailModelList = [];
          this.modalRef = this.modalService.show(template, { class: classes });
        } else {
          this._toastService.addToast({
            title: 'No items Found!',
            msg: 'You picked all items from the Trade Portfolio. Kindly add more properties to trade portfolio and try again.',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'warning',
          });
        }
        this.disableAdd = false;
      });
  }

  addPropertyInComparisonList() {
    this.analyzePropertyDetailModelList = [];
    this.comparePropertiesModel.PropertyIds =
      this.comparePropertiesModel.PropertyIds.concat(
        this.comparePropertiesModel.TenentIds
      );
    this.comparePropertyDetailModelList =
      this.comparePropertyDetailModelList.concat(
        this.comparePropertyDetailCheckedModelList
      );
    this.comparePropertiesModel.TenentIds = [];
    this.comparePropertyDetailCheckedModelList = [];

    if (
      this.comparePropertiesModel.PropertyIds.length !=
      this.comparePropertiesLength
    ) {
      this.loadComparePropertyData(true);
      this.comparePropertiesLength =
        this.comparePropertiesModel.PropertyIds.length;
    } else {
      this._toastService.addToast({
        title: 'Error Occurred',
        msg: 'Please select at least a property',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  onAddPropertyChecked(data) {
    //this.isAnalyze = false;
    if (data.IsChecked) {
      this.comparePropertiesModel.TenentIds.push(data.PropertyId);
      this.comparePropertyDetailCheckedModelList.push(data);
    } else {
      const index: number = this.comparePropertiesModel.TenentIds.indexOf(
        data.PropertyId
      );
      if (index !== -1) {
        this.comparePropertiesModel.TenentIds.splice(index, 1);
      }
    }
  }

  chekAnalyzeProperty(data) {
    if (data.IsChecked) {
      this.analyzePropertyDetailModelList.push(data);
      this.comparePropertiesModel.PropertyIds.push(data.PropertyId);
    } else {
      const index: number = this.analyzePropertyDetailModelList.indexOf(data);
      if (index !== -1) {
        this.analyzePropertyDetailModelList.splice(index, 1);
      }

      const index2: number = this.comparePropertiesModel.PropertyIds.indexOf(
        data.PropertyId
      );
      if (index2 !== -1) {
        this.comparePropertiesModel.PropertyIds.splice(index2, 1);
      }
    }

    this.isAnalyze = false;
  }

  deleteAnalyzeProperty(data) {
    this.isAnalyze = false;

    const index: number = this.comparePropertyDetailModelList.indexOf(data);
    if (index !== -1) {
      this.comparePropertyDetailModelList.splice(index, 1);
    }

    const index1: number = this.analyzePropertyDetailModelList.indexOf(data);
    if (index1 !== -1) {
      this.analyzePropertyDetailModelList.splice(index1, 1);
    }

    const index2: number = this.comparePropertiesModel.PropertyIds.indexOf(
      data.PropertyId
    );
    if (index2 !== -1) {
      this.comparePropertiesModel.PropertyIds.splice(index2, 1);
    }
    this.comparePropertiesLength =
      this.comparePropertiesModel.PropertyIds.length;
    this.getColumnTotalOrAvg();
  }

  getColumnTotalOrAvg() {
    this.comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.LandTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal = 0;
    this.maxCompareValues = new MaxValuesComparisonModel();

    this.comparePropertyDetailModelList.forEach((x) => {
      x.ReturnDuringPrice = 0;

      if (x.AskingPrice != null) {
        this.comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg =
          this.comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg +
          x.AskingPrice;
      }

      //if (x.CapRate != null) {
      //    this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg + x.CapRate
      //}

      if (x.BuildingSize != null) {
        this.comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg =
          this.comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg +
          x.BuildingSize;
      }

      //if (x.ReturnDuringPrice != null) {
      //    this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal = this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal + x.ReturnDuringPrice
      //}

      if (x.Land != null) {
        this.comparePropertyDataTotalOrAvgModel.LandTotalOrAvg =
          this.comparePropertyDataTotalOrAvgModel.LandTotalOrAvg + x.Land;
      }

      if (x.RemainingTerm != null && x.RemainingTerm > 0) {
        this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg =
          this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg +
          x.RemainingTerm;
      }

      //// calculation for Return during price
      if (
        x.NOI != null &&
        x.RentEscalationPercentage != null &&
        x.RentEscalationPercentage != 0
      ) {
        var cYear = this.currentYear;
        var prevNOIValue = x.NOI;
        var period = this.currentYear;

        if (x.LeaseExpirationYear > this.leaseExpirationYear) {
          this.leaseExpirationYear = x.LeaseExpirationYear;
        }

        if (x.RentTermList != undefined && x.RentTermList.length > 0) {
          var startDate = this._ValidationService.convertUTCDateToLocalDate(
            x.RentTermList[0].LeaseStartDate
          );
          var endDate;
          x.RentTermList.forEach((item) => {
            if (!item.IsOptional) {
              x.ReturnDuringPrice =
                +item.NetOperatingIncome.toFixed() + x.ReturnDuringPrice;
              endDate = item.LeaseEndDate;
            }
          });
          endDate = this._ValidationService.convertUTCDateToLocalDate(endDate);
          var months;
          months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
          months -= startDate.getMonth() + 1;
          months += endDate.getMonth();

          //x.NOI = +(x.ReturnDuringPrice / months).toFixed() * 12
        } else {
          while (x.LeaseExpirationYear >= cYear) {
            if (period == cYear && period != this.currentYear) {
              var res = 0;
              res = Math.round(
                (prevNOIValue * x.RentEscalationPercentage) / 100
              );
              prevNOIValue = res + prevNOIValue;
              period = period + x.RentEscalationPeriod;
              x.ReturnDuringPrice = x.ReturnDuringPrice + prevNOIValue;
            } else {
              x.ReturnDuringPrice = x.ReturnDuringPrice + prevNOIValue;
            }

            if (cYear == this.currentYear) {
              period = period + x.RentEscalationPeriod;
            }

            cYear++;
          }
        }
      }

      if (x.NOI != null) {
        this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg =
          this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg + x.NOI;
      }
      // For Highlighte Max Rates

      if (x.AskingPrice > this.maxCompareValues.MaxAskingPrice) {
        this.maxCompareValues.MaxAskingPrice = x.AskingPrice;
      }
      if (x.NOI > this.maxCompareValues.MaxNOI) {
        this.maxCompareValues.MaxNOI = x.NOI;
      }
      if (x.CapRate > this.maxCompareValues.MaxCapRate) {
        this.maxCompareValues.MaxCapRate = x.CapRate;
      }
      if (x.ReturnDuringPrice > this.maxCompareValues.MaxReturnDuringPrice) {
        this.maxCompareValues.MaxReturnDuringPrice = x.ReturnDuringPrice;
      }

      if (x.RemainingTerm > this.maxCompareValues.MaxRemainingTerm) {
        this.maxCompareValues.MaxRemainingTerm = x.RemainingTerm;
      }
      if (x.BuildingSize > this.maxCompareValues.MaxBuildingSize) {
        this.maxCompareValues.MaxBuildingSize = x.BuildingSize;
      }
      if (x.Land > this.maxCompareValues.MaxLand) {
        this.maxCompareValues.MaxLand = x.Land;
      }
      if (x.YearBuilt > this.maxCompareValues.MaxYearBuilt) {
        this.maxCompareValues.MaxYearBuilt = x.YearBuilt;
      }

      if (x.ReturnDuringPrice != null) {
        this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal =
          this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal +
          x.ReturnDuringPrice;
        x.ReturnDuringPrice = Number(x.ReturnDuringPrice.toFixed(2));
      }
    });

    //if (this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg != 0) {
    if (this.comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg == 0) {
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = null;
    } else {
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg =
        (this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg /
          this.comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg) *
        100;
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = Number(
        this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg.toFixed(2)
      );
    }

    // }

    if (this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg != 0) {
      this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg =
        this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg /
        this.comparePropertyDetailModelList.length;
    }

    if (this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal != 0) {
      this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal = Number(
        this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal.toFixed(
          2
        )
      );
    }
  }

  saveAnalyze() {
    if (this.isSaveDisabled == false) {
      this.isSaveDisabled = true;
      if (
        this.comparePropertiesModel.Name != null &&
        this.comparePropertiesModel.Name != undefined &&
        this.comparePropertiesModel.Name != ''
      ) {
        this.comparisonService
          .saveAnalyze(this.comparePropertiesModel)
          .subscribe((response) => {
            if (response) {
              this._toastService.addToast({
                title: 'Success',
                msg: 'Saved Successfully',
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'success',
              });
              this.comparisonService.isComparePage = false;
              //this.comparePropertiesModel.PropertyIds = [];
              this.modalRef.hide();
              //  this.isSaveDisabled = false;
            }
          });
      } else {
        this.isAnalyzeName = true;
        this.isSaveDisabled = false;
      }
    }
  }

  bindPriceChart() {
    const chartData = [];
    const chartXData = [];
    //this.priceChart = new Chart();
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach((item) => {
      const serieData = {
        name:
          item.PropertyName +
          ' ($' +
          this._ValidationService.commaFormat(item.AskingPrice) +
          ')',
        y: item.AskingPrice,
        z: item.AskingPrice,
        color: this.getChartColor(chartCount),
      };
      chartData.push(serieData);
      chartXData.push(item.PropertyName);
      chartCount++;
    });

    Highcharts.chart('priceChart', {
      chart: {
        renderTo: 'priceChart',
        type: this.isFromOfferPortfolio
          ? 'variablepie'
          : this.isPropertyAnalysis
          ? 'column'
          : 'pie',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
            style: {
              fontSize: '12px'
            }
          },
          showInLegend: true,
        },
      },
      series: [
        {
          type: undefined,
          innerSize: this.isFromOfferPortfolio ? '20%' : '0%',
          name: 'Price',
          data: chartData,
        },
      ],
      legend: {
        enabled:
          this.isPropertyAnalysis || this.isFromOfferPortfolio ? false : true,
        itemStyle: {
          fontSize: '12px'
        }
      },
      xAxis: {
        categories: chartXData,
        labels: this.chartLabelOptions
      },
      yAxis: [
        {
          labels: {
            formatter: function () {
              return +this.value / 1000000 + 'M';
            },
            style: {
              fontSize: '12px'
            }
          },
          title: {
            text: 'Price ($)',
            style: {
              fontSize: '12px'
            }
          },
        },
      ],

      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          var priceValue = this.series.data[index].y.toString();
          let propertyName = this.series.data[index].name;
          priceValue += '';
          var x = priceValue.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }

          // return "<b>" + propertyName + " </b><br/>Price :- $" + x1 + x2;
          return '<b>' + propertyName + ' </b>';
        },
      },
    });
  }

  bindNOIChart() {
    const chartData = [];
    const chartXData = [];
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach((item) => {
      const serieData = {
        name:
          item.PropertyName +
          ' ($' +
          this._ValidationService.commaFormat(item.NOI) +
          ')',
        y: item.NOI,
        z: item.NOI,
        color: this.getChartColor(chartCount),
      };
      chartData.push(serieData);
      chartXData.push(item.PropertyName);
      chartCount++;
    });

    Highcharts.chart('NOIChart', {
      chart: {
        renderTo: 'NOIChart',
        type: this.isFromOfferPortfolio
          ? 'variablepie'
          : this.isPropertyAnalysis
          ? 'column'
          : 'pie',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
            style: {
              fontSize: '12px'
            }
          },
          showInLegend: true,
        },
      },
      series: [
        {
          type: undefined,
          innerSize: this.isFromOfferPortfolio ? '20%' : '0%',
          name: 'NOI',
          data: chartData,
        },
      ],
      legend: {
        enabled:
          this.isFromOfferPortfolio || this.isPropertyAnalysis ? false : true,
        itemStyle: {
          fontSize: '12px'
        }
      },
      xAxis: {
        categories: chartXData,
        labels: this.chartLabelOptions
      },
      yAxis: [
        {
          labels: {
            formatter: function () {
              return +this.value / 1000000 + 'M';
            },
            style: {
              fontSize: '12px'
            }
          },
          title: {
            text: 'NOI ($)',
            style: {
              fontSize: '12px'
            }
          },
        },
      ],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          var priceValue = this.series.data[index].y.toString();
          let propertyName = this.series.data[index].name;
          priceValue += '';
          var x = priceValue.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }

          //return "<b>" + propertyName + " </b><br/>NOI :- $" + x1 + x2;
          return '<b>' + propertyName + ' </b>';
        },
      },
    });
  }

  bindReturnDuringLeaseChart() {
    const chartData = [];
    const chartXData = [];
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach((item) => {
      const serieData = {
        name: item.PropertyName,
        y: Math.round(item.ReturnDuringPrice * 100) / 100,
        z: Math.round(item.ReturnDuringPrice * 100) / 100,
        color: this.getChartColor(chartCount),
      };
      chartData.push(serieData);
      chartXData.push(item.PropertyName);
      chartCount++;
    });

    Highcharts.chart('returnDuringLeaseChart', {
      chart: {
        renderTo: 'returnDuringLeaseChart',
        type: this.isFromOfferPortfolio
          ? 'variablepie'
          : this.isPropertyAnalysis
          ? 'column'
          : 'pie',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          type: undefined,
          innerSize: this.isFromOfferPortfolio ? '20%' : '0%',
          name: 'Return During Lease',
          data: chartData,
        },
      ],
      xAxis: {
        categories: chartXData,
        labels: this.chartLabelOptions
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
            style: {
              fontSize: '12px'
            }
          },
          showInLegend: true,
        },
      },
      legend: {
        enabled:
          this.isFromOfferPortfolio || this.isPropertyAnalysis ? false : true,
        itemStyle: {
          fontSize: '12px'
        }
      },
      yAxis: [
        {
          labels: {
            formatter: function () {
              return +this.value / 1000000 + 'M';
            },
            style: {
              fontSize: '12px'
            }
          },
          title: {
            text: 'Return During Lease ($)',
            style: {
              fontSize: '12px'
            }
          },
        },
      ],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          let priceValue = this.series.data[index].y.toString();
          let propertyName = this.series.data[index].name;
          priceValue += '';
          var x = priceValue.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }

          return (
            '<b>' + propertyName + ' </b><br/>Return During Lease:- $' + x1 + x2
          );
        },
      },
    });
  }

  bindRemainingTermChart() {
    const chartData = [];
    const chartXData = [];
    let chartCount = 0;

    this.analyzePropertyDetailModelList.forEach((item) => {
      if (item.RemainingTerm != null && item.RemainingTerm > 0) {
        var result = parseFloat(
          this.yearMonthConverter(item.RemainingTerm, true)
        );
        // var s = parseFloat(Number(this.yearMonthConverter(item.RemainingTerm, true)).toFixed(2));
        //var remainingTermData = +result;
        const serieData = {
          name: item.PropertyName,
          y: result,
          color: this.getChartColor(chartCount),
        };
        chartData.push(serieData);
        chartXData.push(item.PropertyName);
        chartCount++;
      }
    });

    Highcharts.chart('remainingTermChart', {
      chart: {
        renderTo: 'remainingTermChart',
        type: 'column',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: chartXData,
        labels: this.chartLabelOptions
      },
      yAxis: {
        title: {
          text: 'Years',
          style: {
            fontSize: '12px'
          }
        },
        labels: this.chartLabelOptions
      },
      legend: {
        enabled: false,
        itemStyle: {
          fontSize: '12px'
        }
      },
      series: [
        {
          type: undefined,
          name: 'Remaining Term',
          data: chartData,
        },
      ],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          var rm = this.series.data[index].y;
          let propertyName = this.series.data[index].name;

          return (
            '<b>' +
            propertyName +
            ' </b><br/> Remaining Term:- ' +
            rm +
            ' Years'
          );
        },
      },
    });
  }

  bindLandAreaChart() {
    const chartData = [];
    let chartCount = 0;

    this.analyzePropertyDetailModelList.forEach((item) => {
      const serieData = {
        name: item.PropertyName,
        data: [item.Land],
        color: this.getChartColor(chartCount),
        // colorByPoint: true
        // color: '#' + Math.random().toString(16).slice(2, 8)
      };
      chartData.push(serieData);
      chartCount++;
    });

    const plotOptions = {
      colorByPoint: true,
    };

    Highcharts.chart('landAreaChart', {
      chart: {
        renderTo: 'landAreaChart',
        type: 'column',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: [''],
        visible: false,
        labels: this.chartLabelOptions
      },
      yAxis: {
        title: {
          text: 'Acres',
          style: {
            fontSize: '12px'
          }
        },
        labels: this.chartLabelOptions
      },
      plotOptions: {
        series: {},
      },
      legend: {
        enabled: true,
        itemStyle: {
          fontSize: '12px'
        }
      },
      series: chartData,
    });
  }

  bindCreditRatingChart() {
    const chartData = [];
    const creditRatingData = [];
    var totalPrice = 0;

    this.analyzePropertyDetailModelList.forEach((item) => {
      totalPrice = totalPrice + item.AskingPrice;
    });

    this.analyzePropertyDetailModelList.forEach((item) => {
      const CRData = {
        propertyName: item.PropertyName,
        rating: item.Rating != null ? item.Rating : 0,
        // pricePercentage: ((item.AskingPrice / totalPrice) * 100)
        pricePercentage:
          Math.round((item.AskingPrice / totalPrice) * 100 * 100) / 100,
      };
      creditRatingData.push(CRData);
    });

    const resultList = [];
    var result = this.groupBy(creditRatingData, function (item) {
      return [item.rating];
    });
    resultList.push(result);
    let chartCount = 0;
    resultList.forEach((item) => {
      item.forEach((data) => {
        this.priceTotal = 0;
        let propertyName = '';
        if (data.length > 1) {
          data.forEach((res) => {
            this.priceTotal = this.priceTotal + res.pricePercentage;
            propertyName = propertyName + '<br/>' + res.propertyName;
          });
          const serieData = {
            name:
              '<br/> Credit Rating - ' +
              data[0].rating +
              '(' +
              data.length +
              ' prop)' +
              '<br/>' +
              propertyName,
            y: this.priceTotal,
            z: this.priceTotal,
            color: this.getChartColor(chartCount),
          };
          chartData.push(serieData);
          chartCount++;
        } else {
          const serieData1 = {
            //name: data[0].rating,
            name:
              '<br/> Credit Rating - ' +
              data[0].rating +
              '<br/>' +
              data[0].propertyName,
            y: data[0].pricePercentage,
            z: data[0].pricePercentage,
            color: this.getChartColor(chartCount),
          };
          chartData.push(serieData1);
          chartCount++;
        }
      });
    });

    Highcharts.chart('creditRatingChart', {
      chart: {
        renderTo: 'creditRatingChart',
        type: this.isFromOfferPortfolio ? 'variablepie' : 'pie',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
            style: {
              fontSize: '12px'
            }
          },
          showInLegend: true,
        },
      },
      legend: {
        enabled:
          this.isFromOfferPortfolio || this.isPropertyAnalysis ? false : true,
        itemStyle: {
          fontSize: '12px'
        }
      },
      series: [
        {
          type: undefined,
          innerSize: this.isFromOfferPortfolio ? '20%' : '0%',
          name: 'Credit Rating (%)',
          data: chartData,
        },
      ],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          let name = this.series.data[index].name;

          return name;
        },
      },
    });
  }

  bindCapRateChartForPrpertyAnalysis() {
    const chartData = [];
    const chartXData = [];
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach((item) => {
      const serieData = {
        name: item.PropertyName,
        y: item.CapRate != null ? item.CapRate : 0,
        color: this.getChartColor(chartCount),
      };
      chartData.push(serieData);
      chartXData.push(item.PropertyName);
      chartCount++;
    });

    Highcharts.chart('capRateChart', {
      chart: {
        renderTo: 'capRateChart',
        type: 'column',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: [{
        title: {
          text: 'Cap Rate (%)',
          style: {
            fontSize: '12px'
          }
        },
        labels: this.chartLabelOptions
      }],
      series: [
        {
          type: undefined,
          name: 'Cap Rate (%)',
          data: chartData,
        },
      ],
      xAxis: {
        categories: chartXData,
        labels: this.chartLabelOptions
      },
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          var priceValue = this.series.data[index].y;
          let propertyName = this.series.data[index].name;

          return '<b>' + propertyName + ' </b><br/>Cap Rate :- ' + priceValue;
        },
      },
    });
  }

  bindCapRateChart() {
    const chartData = [];
    const capRateData = [];
    var totalPrice = 0;
    this.analyzePropertyDetailModelList.forEach((item) => {
      totalPrice = totalPrice + item.AskingPrice;
    });

    this.analyzePropertyDetailModelList.forEach((item) => {
      // if (item.CapRate != null) {
      const CRData = {
        propertyName: item.PropertyName,
        capRate: item.CapRate != null ? item.CapRate : 0,
        pricePercentage: (item.AskingPrice / totalPrice) * 100,
        // pricePercentage:(Math.round(((item.AskingPrice / totalPrice) * 100) * 100) / 100),
      };
      capRateData.push(CRData);
      // }
    });

    const resultList = [];
    var result = this.groupBy(capRateData, function (item) {
      return [item.capRate];
    });
    resultList.push(result);
    let chartCount = 0;
    resultList.forEach((item) => {
      item.forEach((data) => {
        this.priceTotal = 0;
        let propertyName = '';
        if (data.length > 1) {
          data.forEach((res) => {
            this.priceTotal = this.priceTotal + res.pricePercentage;
            propertyName = propertyName + '<br/>' + res.propertyName;
          });
          const serieData = {
            name:
              '<br/> Cap Rate - ' +
              data[0].capRate +
              '% (' +
              data.length +
              ' prop)' +
              '<br/>' +
              propertyName,
            ////y: (Math.round(this.priceTotal * 100) / 100),
            ////z: (Math.round(this.priceTotal * 100) / 100),
            y: data[0].capRate,
            z: data[0].capRate,
            color: this.getChartColor(chartCount),
          };
          chartData.push(serieData);
          chartCount++;
        } else {
          const serieData1 = {
            // name: data[0].capRate,
            //y: data[0].pricePercentage,
            name:
              '<br/> Cap Rate - ' +
              data[0].capRate +
              '% <br/>' +
              data[0].propertyName,
            y: Math.round(data[0].capRate * 100) / 100,
            z: Math.round(data[0].capRate * 100) / 100,
            color: this.getChartColor(chartCount),
          };
          chartData.push(serieData1);
          chartCount++;
        }
      });
    });

    Highcharts.chart('capRateChart', {
      chart: {
        renderTo: 'capRateChart',
        type: this.isFromOfferPortfolio
          ? 'variablepie'
          : this.isPropertyAnalysis
          ? 'column'
          : 'pie',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
            style: {
              fontSize: '12px'
            }
          },
          showInLegend: true,
        },
      },
      legend: {
        enabled: this.isPropertyAnalysis ? false : true,
      },
      series: [
        {
          type: undefined,
          innerSize: this.isFromOfferPortfolio ? '20%' : '0%',
          name: 'Cap Rate (%)',
          data: chartData,
        },
      ],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          let name = this.series.data[index].name;

          return name;
        },
      },
    });
  }

  bindRevenueChart() {
    const chartData = [];
    this.leaseExpirationYear = this.currentYear;
    var xAxisData = [];
    xAxisData = [];

    const lineChartData = new Array(1);
    lineChartData[0] = 0;
    let lineChartData2 = [];
    lineChartData2[0] = 0;
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach((item) => {
      //var linechart = [];
      //var lineOptionChart = [];
      const data = [];
      if (item.RentTermList != undefined && item.RentTermList.length > 0) {
        var chartStartYear = this.currentYear;
        let count = 0;
        item.RentTermList.forEach((rentTerm) => {
          var startDate = this._ValidationService.convertUTCDateToLocalDate(
            rentTerm.LeaseStartDate
          );
          var startYear = startDate.getFullYear();
          var endDate = this._ValidationService.convertUTCDateToLocalDate(
            rentTerm.LeaseEndDate
          );
          var endYear = endDate.getFullYear();
          var yearDiff = endDate.getFullYear() - startDate.getFullYear();
          yearDiff = yearDiff > 0 ? yearDiff : 1;
          let k = yearDiff == 1 ? 1 : 0;

          for (let i = k; i <= yearDiff; i++) {
            while (chartStartYear < startYear) {
              if (!rentTerm.IsOptional) {
                data.push(null);
                if (lineChartData[count] == undefined) {
                  lineChartData.push(null);
                }
              }

              if (lineChartData2[count] == undefined) {
                lineChartData2.push(null);
              }
              chartStartYear++;
              count++;
            }

            if (chartStartYear == startYear) {
              if (!rentTerm.IsOptional) {
                data.push(rentTerm.NetOperatingIncome);
                if (lineChartData[count] != undefined) {
                  lineChartData[count] =
                    lineChartData[count] + rentTerm.NetOperatingIncome;
                } else {
                  lineChartData.push(rentTerm.NetOperatingIncome);
                }
              }

              if (lineChartData2[count] != undefined) {
                lineChartData2[count] =
                  lineChartData2[count] + rentTerm.NetOperatingIncome;
              } else {
                lineChartData2.push(rentTerm.NetOperatingIncome);
              }

              if (xAxisData.indexOf(chartStartYear) == -1) {
                xAxisData.push(chartStartYear);
              }
              chartStartYear++;
              count++;
            }
            startYear++;
          }
        });

        const serieData = {
          name: item.PropertyName,
          data: data,
          type: 'column',
          color: this.getChartColor(chartCount),
        };
        chartData.push(serieData);
        chartCount++;
      } else {
        if (
          item.NOI != null &&
          item.RentEscalationPercentage != null &&
          item.RentEscalationPercentage != 0
        ) {
          var chartStartYear = this.currentYear;
          var commencementYear = item.LeaseCommencementYear;
          var prevNOIValue = item.NOI;
          var extendedNOIValue = item.NOI;
          var period = item.LeaseCommencementYear;

          if (item.LeaseExpirationYear > this.leaseExpirationYear) {
            this.leaseExpirationYear = item.LeaseExpirationYear;
            //xAxisData = [];
          }

          let count = 0;
          while (this.expirationYear >= commencementYear) {
            if (
              period == commencementYear &&
              period != item.LeaseCommencementYear
            ) {
              var res = 0;
              res = (prevNOIValue * item.RentEscalationPercentage) / 100;
              res = Math.round(res * 100) / 100;
              prevNOIValue = Math.round(res + prevNOIValue);

              res = 0;
              res = (extendedNOIValue * item.RentEscalationPercentage) / 100;
              res = Math.round(res * 100) / 100;
              extendedNOIValue = Math.round(res + extendedNOIValue);

              if (
                commencementYear >= chartStartYear &&
                item.LeaseExpirationYear >= commencementYear
              ) {
                data.push(prevNOIValue);
              }
              period = period + item.RentEscalationPeriod;
            } else if (
              commencementYear >= chartStartYear &&
              item.LeaseExpirationYear >= commencementYear
            ) {
              data.push(prevNOIValue);
            }

            if (
              this.leaseExpirationYear == item.LeaseExpirationYear &&
              commencementYear >= chartStartYear &&
              xAxisData.indexOf(commencementYear) == -1
            ) {
              xAxisData.push(commencementYear);
            }

            if (commencementYear == item.LeaseCommencementYear) {
              period = period + item.RentEscalationPeriod;
            }
            if (commencementYear >= chartStartYear) {
              if (item.LeaseExpirationYear >= commencementYear) {
                if (
                  lineChartData[count] != undefined &&
                  lineChartData[count] != null
                ) {
                  lineChartData[count] =
                    lineChartData[count] +
                    (prevNOIValue == null ? 0 : prevNOIValue);
                } else {
                  lineChartData.push(prevNOIValue == null ? 0 : prevNOIValue);
                }
              }

              if (
                lineChartData2[count] != undefined &&
                lineChartData2[count] != null
              ) {
                lineChartData2[count] =
                  lineChartData2[count] + extendedNOIValue;
              } else {
                lineChartData2.push(extendedNOIValue);
              }

              count++;
            }
            commencementYear++;
          }
          //while (item.LeaseExpirationYear >= cYear) {
          //
          //    if (period == cYear && period != this.currentYear) {
          //        var res = 0;
          //        res = ((prevNOIValue * item.RentEscalationPercentage) / 100);
          //        res = Math.round(res * 100) / 100;
          //        prevNOIValue = res + prevNOIValue;
          //        data.push(prevNOIValue);
          //        period = period + item.RentEscalationPeriod;
          //    }
          //    else {
          //        data.push(prevNOIValue);
          //    }

          //    if (this.leaseExpirationYear == item.LeaseExpirationYear) {
          //        xAxisData.push(cYear);
          //    }

          //    if (cYear == this.currentYear) {
          //        period = period + item.RentEscalationPeriod;
          //    }

          //    if (lineChartData[count] != undefined) {
          //        lineChartData[count] = lineChartData[count] + prevNOIValue;
          //    }
          //    else {
          //        lineChartData.push(prevNOIValue);
          //    }

          //    cYear++;
          //    count++;
          //}
          const serieData = {
            name: item.PropertyName,
            data: data,
            type: 'column',
            color: this.getChartColor(chartCount),
          };
          chartData.push(serieData);
          chartCount++;
        }
      }
    });

    if (!this.isPropertyAnalysis) {
      if (lineChartData.length > xAxisData.length) {
        let diff =
          xAxisData[xAxisData.length - 1] - xAxisData[xAxisData.length - 2];
        while (
          !(
            lineChartData.length == xAxisData.length ||
            lineChartData.length < xAxisData.length
          )
        ) {
          xAxisData.push(xAxisData[xAxisData.length - 1] + diff);
        }
      }

      const lineData = {
        type: 'spline',
        name: 'Total NOI',
        data: lineChartData,
      };
      chartData.push(lineData);

      if (this.enableExtendedChart) {
        if (lineChartData2.length > xAxisData.length) {
          let diff =
            xAxisData[xAxisData.length - 1] - xAxisData[xAxisData.length - 2];
          while (
            !(
              lineChartData2.length == xAxisData.length ||
              lineChartData2.length < xAxisData.length
            )
          ) {
            xAxisData.push(xAxisData[xAxisData.length - 1] + diff);
          }
        }
        const lineData2 = {
          type: 'spline',
          name: 'Total Extended NOI',
          data: lineChartData2,
        };
        chartData.push(lineData2);
      }
    }

    Highcharts.chart('revenueChart', {
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: xAxisData,
        //visible: false
        title: {
          text: 'Years',
          style: {
            fontSize: '12px'
          }
        },
        min: 0,
        labels: this.chartLabelOptions
      },
      yAxis: {
        labels: {
          formatter: function () {
            return +this.value / 1000000 + 'M';
          },
          style: {
            fontSize: '12px'
          }
        },
        title: {
          text: 'NOI',
          style: {
            fontSize: '12px'
          }
        }
      },
      plotOptions: {
        series: {
          connectNulls: true,
        },
      },
      legend: {
        enabled: true,
        itemStyle: {
          fontSize: '12px'
        }
      },
      series: chartData,
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          let priceValue = this.series.data[index].y.toString();
          let propertyNameData = this.series.name;
          priceValue += '';
          var x = priceValue.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }

          return '<b>' + propertyNameData + ' </b><br/>NOI :- $' + x1 + x2;
        },
      },
    });
  }

  yearMonthConverter(valuex: number | string, abbr?: boolean): string {
    if (!valuex) {
      return '-';
    }

    const value = parseFloat(valuex.toString());

    // (int)Math.Floor(x.LeaseExpiration.Value.Subtract(DateTime.Now).Days / (365.25 / 12))
    const months = Math.floor(value / (365.25 / 12)); // actual months

    const years = Math.floor(months / 12);

    const yrs = years > 1 ? (abbr ? 'yrs' : 'years') : abbr ? 'yr' : 'year';
    const mnts =
      months % 12 > 1 ? (abbr ? 'mo' : 'months') : abbr ? 'mo' : 'month';

    const days = +valuex > 1 ? 'days' : abbr ? 'd' : 'day';

    if (years > 0 && months % 12 === 0) {
      return `${years}`;
    } else if (years === 0 && months % 12 > 0) {
      return `.${months % 12}`;
    } else if ((years < 1 && months < 1) || (years === 0 && months === 0)) {
      if (years === 0 && months === 0 && +valuex > 0) {
        return `.${valuex}`;
      }

      return `Expired`;
    } else {
      return `${years}.${months % 12}`;
    }
  }

  groupBy(array, f) {
    var groups = {};
    array.forEach(function (o) {
      var group = JSON.stringify(f(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(function (group) {
      return groups[group];
    });
  }

  getChartColor(index) {
    const colors = [
      '#198FDE',
      '#003A5D',
      '#59595B',
      '#02C29F',
      '#A7A8A9',
      '#FFC32B',
      '#FF4438',
      ' #6596D6 ',
      ' #67A7FA ',
      ' #1967CB ',
      ' #0D77FF ',
      ' #004298 ',
      ' #285CA1 ',
      ' #55759E ',
      ' #4788DC ',
      ' #5167EA ',
      ' #2B44D8 ',
      ' #7582CF ',
      ' #4354B9 ',
      ' #0F24A4 ',
      ' #1458E2 ',
      ' #3562BF ',
      ' #305297 ',
      ' #333286 ',
      ' #98C7FF ',
      ' #4886D8 ',
      ' #2C99D7 ',
      ' #157BB5 ',
      ' #0C6699 ',
      ' #49A1D3 ',
      ' #62BFF3 ',
      ' #51B5D1 ',
      ' #6186D3 ',
      ' #33C5DF ',
      ' #21A5BC ',
      ' #277583 ',
      ' #274183 ',
      ' #21459E ',
      ' #4674E6 ',
      ' #3355AA ',
      ' #596C9C ',
      ' #503C8D ',
      ' #6042BE ',
      ' #906CFF ',
      ' #B08CC8 ',
      ' #A374AE ',
      ' #B4658E ',
      ' #CA62DF ',
      ' #A264D9 ',
      ' #90B36C ',
      ' #6C963D ',
      ' #6AB16A ',
      ' #75D285 ',
      ' #B3BB66 ',
      ' #C77272 ',
      ' #D75555 ',
      ' #A34646 ',
    ];
    return colors[index];
  }

  changeBreadCrumb() {
    this.comparisonService.isComparePage = false;
  }

  cancelComparison(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  openAnalyzeModal(template: TemplateRef<any>, classes: any) {
    this.comparePropertiesModel.Name = null;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  cancelSuccess() {
    //this.comparePropertiesModel.PropertyIds = [];
    this.comparisonService.isComparePage = false;
    this.modalRef.hide();
    this.goBack();
  }

  scrollToBottom(element, offset) {
    $('html,body').animate({ scrollTop: $(element).offset().top - 80 }, 500);
  }

  //pdfDownload() {
  //    //var chart = $('#capture').highcharts();
  //    //chart.exportChart({
  //    //    type: 'application/pdf',
  //    //    filename: 'my-pdf'
  //    //});

  //    this.loaderService.display(true);
  //    var doc = new jsPDF('p', 'mm', [410, 220]);

  //    html2canvas(document.querySelector("#capture")).then(function (canvas) {
  //        var imgData = canvas.toDataURL("jpeg");
  //        doc.addImage(imgData, 'JPEG', 2, 2, 210, 406);
  //        doc.save('Pipeline.pdf');
  //    });

  //    setTimeout(() => {
  //        this.loaderService.display(false);
  //    }, 5000);
  //}

  pdfDownload() {
    $('body').removeClass('open-sidemenu');
    this.loaderService.display(true);
    setTimeout(() => {
      var divHeight = $('#capture').height();
      var divWidth = $('#capture').width() + 10;
      var ratio = divHeight / divWidth;
      var docDefinition = {};
      html2canvas(document.querySelector('#capture'), {
        scale: 2,
        height: divHeight,
        width: divWidth,
      }).then(function (canvas) {
        var data = canvas.toDataURL();
        var tenant = $('#tenant :selected').text();
        docDefinition = {
          pageMargins: [45, 20, 5, 20],
          pageSize: {
            width: 870,
            height: 'auto',
          },
          content: [
            {
              image: data,
              width: 800,
              height: ratio * 870,
            },
          ],
        };
        pdfMake.createPdf(docDefinition).download('Pipeline.pdf');
      });
    }, 1000);
    setTimeout(() => {
      this.loaderService.display(false);
    }, 5000);
  }

  //pdfDownload() {

  //  this.loaderService.display(true);
  //  setTimeout(() => {
  //    var divHeight = $('#capture').height();
  //    var divWidth = $('#capture').width();
  //    var ratio = divHeight / divWidth;
  //    var docDefinition = {};
  //    html2canvas(document.querySelector("#capture"), {
  //      scale: 1.5,
  //      height: divHeight,
  //      width: divWidth,
  //    }).then(function (canvas) {
  //      var data = canvas.toDataURL();
  //      var tenant = $('#tenant :selected').text();
  //      docDefinition = {
  //        pageMargins: [20, 20, 30, 20],
  //        pageSize: {
  //          width: 842,
  //          height: 'auto'
  //        },
  //        content: [{
  //          image: data,
  //          width: 800,
  //          height: (ratio * 842)
  //        }]
  //      };
  //      pdfMake.createPdf(docDefinition).download('Pipeline.pdf');
  //    });
  //  }, 1000);

  //  setTimeout(() => {
  //    this.loaderService.display(false);
  //  }, 5000);
  //}
  goBack() {
    if (this.router.url.indexOf('compare') > -1) {
      this.router.navigateByUrl(
        '/' + this.prevPageRouteLink + '?tab=portfolio'
      );
    }
  }
}
